import React, { useEffect } from "react";

const OneSection = () => {

    useEffect(() => {

    }, []);

    return (
        <div className="c_section c_oneSection">
            <div className="c_body">
                <div className="c_images">
                    <img className="c_images__img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/sections/bg/1.png" />
                </div>
            </div>
        </div>
    );
};

export default OneSection;